<ui-card>
    <div class="ui">
        <app-segment-header
            title="{{ 'applicant-tracker.applicants.basicInformation' | appTranslate }}"
            (edit)="handleEditClick()"
        >
        </app-segment-header>
    </div>
    <div class="flex wrap">
        <div>
            <h4 class="heading">{{ 'applicant-tracker.applicants.email' | appTranslate }}</h4>
            <div>{{ applicant?.email || 'None' }}</div>
        </div>

        <div class="margin-left-5">
            <h4 class="heading">{{ 'applicant-tracker.applicants.phoneNumber' | appTranslate }}</h4>
            <div>{{ applicant?.phone || '' }}</div>
        </div>

        <div class="margin-left-5">
            <h4 class="heading">{{ 'applicant-tracker.applicants.postalCode' | appTranslate }}</h4>
            <div>{{ applicant?.postalCode || '' }}</div>
        </div>

        <div class="margin-left-5">
            <h4 class="heading">{{ 'applicant-tracker.applicants.country' | appTranslate }}</h4>
            <div>{{ applicant?.country || '' }}</div>
        </div>
    </div>
</ui-card>
